import { Injectable } from '@angular/core';
import { Subject, Observable, of, interval, Subscription, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { CommonHttpService } from './common-http.service';
import { StorageService } from './storage.service';
import { CommonService } from './common.service';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { FormGroup } from '@angular/forms';
import { AssessmentModalComponent } from 'src/app/components/assessment-modal/assessment-modal.component';
import { LanguageModalComponent } from 'src/app/components/language-modal/language-modal.component';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public userloginForm!: FormGroup;
  public loginErrResp: string = '';
  public loginErrMsg: string = '';
  contactguid: any;
  secKey: any;
  ifOtpAuthenticated: any;
  contactEmail: any;
  inactiveTimer: any;
  modalRef!: BsModalRef;
  serverSubscription!: Subscription;
  serverCheckInterval: any;
  isLoginFailed: boolean = false;
  constructor(private _commonHttpService: CommonHttpService, private storageService: StorageService,
    private commonService: CommonService, private route: Router, private modalService: BsModalService, private http: HttpClient) { }

  public loadConfig(): Observable<any> {
  const url = this.commonService.getFullUrl(GlobalConstants.CONFIG);
  return this._commonHttpService.get(url, {}, {}).pipe(
    map(response => {
      if (response && response.body) {
        return response.body;   
      } else {
        throw new Error('No response body');
      }
    }),
    catchError(error => {
      console.error('Error fetching the key:', error);
      return throwError(() => error);  
    })
  );
}
  public verifyUser(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.LOGIN);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('contacts response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public checkIfUserRequestExists(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.CHECK_IF_USER_REQUEST_EXISTS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('contacts response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
  public checkIfContactExists(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.CHECK_IF_CONTACT_EXISTS);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('contacts response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public sendEmailWithOtp(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.SEND_EMAIL_WITH_OTP);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('sending email response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public updateWrongOtpCount(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.UPDATE_WRONG_OTP_COUNT);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('sending otp count response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public registerUser(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.REGISTRATION);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('contacts saving response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public setPassword(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.SET_PASSWORD);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('password change response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public createCase(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.CREATE_CASE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('request user access response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public reopenCase(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.REOPEN_CASE);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          //console.log('reopen case response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }

  public checkServerStatus(): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.CHECK_SERVER_STATUS);
    return this._commonHttpService.get(url, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          return response.body;
        } else {
          return error;
        }
      }));
  }


  public logoutUser() {
    const UAEPassUser = this.storageService.getSessionStorageData('isUAEPass');
    this.storageService.clearAllSessionStorageData();
    this.clearServerInterval();
    clearTimeout(this.inactiveTimer);
    const redirectUri = encodeURIComponent(window.location.origin + '/#/login');
    localStorage.removeItem('auth_token');
    if (UAEPassUser) {
      const uaepassEndPoint = 'https://stg-id.uaepass.ae/'
      const logoutUrl = `${uaepassEndPoint}idshub/logout?redirect_uri=${redirectUri}`;
      window.location.href = logoutUrl;
    } else {
      window.location.href = window.location.origin + '/#/login';
    }
  }
  public fetchUserAssessmentAccounts(data: any): Observable<any> {
    const url = this.commonService.getFullUrl(GlobalConstants.FETCH_USER_ASSESSMENT_ENTITIES);
    let encryptedRqstBody = {
      rqstBody: this.commonService.encryptUsingAES256(data)
    }
    console.log("calling http")
    return this._commonHttpService.post(url, encryptedRqstBody, {}, {})
      .pipe(map((response, error) => {
        if (response) {
          // console.log('fetchUserAssessmentAccounts response: ', response);
          return response.body;
        } else {
          return error;
        }
      }));
  }
  fetchUserAssAccounts() {
    // console.log("fetch user ass account called")
    const userData = this.storageService.getSessionStorageData('userDetails');

    const req = {
      email: userData?.email
    };
    let accounts: any = []
    this.fetchUserAssessmentAccounts(req).subscribe((data: any) => {
      // console.log("data :", data)
      if (data?.data) {
        try {
   //console.log("response ------- ", data?.data)
          const decryptedResp = this.commonService.decryptUsingAES256(data?.data);
          const parsedResp = typeof decryptedResp === 'string' ? JSON.parse(decryptedResp) : decryptedResp;
   //console.log("parsed resp", parsedResp)
          if (parsedResp.assessmentAccounts && Array.isArray(parsedResp.assessmentAccounts)) {
            accounts = parsedResp.assessmentAccounts;
            this.storageService.setSessionStorageData('accounts', accounts);

     //console.log("accounts ", accounts)
            if (accounts && accounts.length == 1) {
       //console.log("direct login")
              this.openLanguageModal();
            } else if (accounts && accounts.length > 1) {
       //console.log("popup ", accounts.length)
              this.openAssessmentModal();
            }
          } else {
            accounts = [];
            console.warn('No assessmentAccounts found in response');
          }
        } catch (err) {
          console.error('Error parsing decrypted response:', err);
        }
      } else {
        console.warn('No data from API response');
      }
    }, err => {
      console.error('Error fetching assessment accounts:', err);
    });
  }
  openAssessmentModal() {
    // console.log("openAssessmentModal opening.....")
    this.modalRef = this.modalService.show(AssessmentModalComponent, {
      class: 'modal-lg',
      initialState: {
        assessmentAccounts: this.storageService.getSessionStorageData("accounts")
      }
    });

    this.modalRef.content?.onClose?.subscribe((selectedAccount: string) => {
      // console.log('Modal closed with choice:', selectedAccount);

      const userData = this.storageService.getSessionStorageData('userDetails');

      let req = { email: userData?.email, selectedAccount: selectedAccount }
      //handle login with selected assessment entitiy
      this.http.post(`/api/loginAssessmentAccountForUaePass`, req).subscribe({
        next: (res: any) => {
   //console.log('Response from /api/loginAssessmentAccountForUaePass:', res);
          if (!res?.body?.data) {
            console.warn('No encrypted data found in response body');
            this.loginErrMsg = "Login response missing required data.";
            this.isLoginFailed = true;
            return;
          }
          try {
            const decryptedRes = this.commonService.decryptUsingAES256(res?.body?.data);
            // console.log('Decrypted response data:', decryptedRes);

            if (decryptedRes?.isAuth === true) {
       //console.log('User is authenticated, setting session');
              if (decryptedRes.token) {
         //console.log('Storing token from decrypted response');
                localStorage.setItem('auth_token', decryptedRes.token);
              }
              this.setSession(decryptedRes);
              this.storageService.setSessionStorageData('isUAEPass', true);
              this.openLanguageModal()
            } else {
              // console.warn('Authentication failed or isAuth flag not true:', decryptedRes);
              this.loginErrMsg = "Currently, the portal access is restricted for the UAE PASS user. However please reach out to below team for further review.";
              this.isLoginFailed = true;
              // Optionally, log the decrypted response for further insight
              // this.loginErrResp = 'UAE Pass login failed.';
            }
          } catch (error) {
            console.error('Error decrypting the response data:', error);
            this.loginErrMsg = "Failed to process the login response. Please try again later.";
            this.isLoginFailed = true;
          }
        },
        error: (err) => {
          console.error('Error during /api/uaepass HTTP call:', err);
          this.loginErrMsg = "Currently, the portal access is restricted for the UAE PASS user. However please reach out to below team for further review.";
          this.isLoginFailed = true;
          this.loginErrResp = 'Error during UAE PASS login.';
        }
      });

    });
  }
  setSession(decryptedData: any) {
    this.storageService.setSessionStorageData('isAuth', true);
    this.storageService.setSessionStorageData('userDetails', decryptedData);
    let isChecker = decryptedData.role === 'Checker';
    this.storageService.setSessionStorageData('isChecker', isChecker);
    this.storageService.setSessionStorageData('isMakerCheckerEnabled', decryptedData.executorMakerCheckerEnabled);
    this.startPortalInActiveTimer(decryptedData.recordType);
    this.startServerStatusCheck();
    this.storageService.setSessionStorageData('isFirstTime', decryptedData.firsttime);
    this.sendLoginLogsToServer(sessionStorage.getItem('userDetails'));
    this.sendLoginDateToServer(sessionStorage.getItem('userDetails'));
  }

  openLanguageModal() {
    let config = { class: 'lang-modal' };
    this.modalRef = this.modalService.show(LanguageModalComponent, config);
  }

  sendLoginLogsToServer(userData: any) {
    this.http.post(`/api/loginlogs`, { rqstBody: userData }).subscribe({
      next: (response) => {
        // console.log('login logs synced with server:', response);
      },
      error: (err) => {
        // console.error('Failed to sync session details:', err);
      }
    });
  }
  sendLoginDateToServer(userData: any) {
    this.http.post(`/api/logindate`, { rqstBody: userData }).subscribe({
      next: (response) => {
        // console.log('login logs synced with server:', response);
      },
      error: (err) => {
        // console.error('Failed to sync session details:', err);
      }
    });
  }
  setContactguid(contactguid: any) {
    this.contactguid = contactguid;
  }

  getContactguid() {
    return this.contactguid;
  }

  setIfOtpAuthenticated(otpStatus: any) {
    this.ifOtpAuthenticated = otpStatus;
  }

  getIfOtpAuthenticated() {
    return this.ifOtpAuthenticated;
  }

  setContactEmailId(contactEmail: any) {
    this.contactEmail = contactEmail;
  }

  getContactEmailId() {
    return this.contactEmail;
  }


  startPortalInActiveTimer(recordType: any = 'login') {
    this.inactiveTimer = setTimeout(() => {
      //console.log('logged out');
      this.storageService.clearAllSessionStorageData();
      this.clearServerInterval();
      clearTimeout(this.inactiveTimer);
      this.showPortalInactivePopup(recordType);
    }, GlobalConstants.USER_SESSION.TIMEOUT.MILISEC);
  }

  // 900000

  clearPortalInactiveTimeout() {
    clearTimeout(this.inactiveTimer)
    this.startPortalInActiveTimer();
  }

  clearOnlyTimeout() {
    clearTimeout(this.inactiveTimer);
  }

  showPortalInactivePopup(recordType: any) {
    let pathUrl = recordType === 'DAFZ Account' ? 'https://dafz.my.site.com/dafzcustomer' : 'login';

    const initialState = {
      message: 'You have been logged out due to inactivity for more than 30 mins, please login again.',
      arabicMessage: "تم تسجيل خروجك بسبب عدم التفاعل مع الصفحة لمدة تزيد عن 30 دقيقة، يرجى تسجيل الدخول مرة أخرى.",
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }
  showSsoErrorPopup(msg: string) {
    let pathUrl = 'login';
    const initialState = {
      message: msg,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }
  startServerStatusCheck() {
    let that = this;
    this.serverCheckInterval = setInterval(() => {
      that.serverSubscription = that.checkServerStatus().subscribe((res: any) => {
        //console.log('server status checked');
      });
    }, GlobalConstants.USER_SESSION.SERVER_STATUS_CHECK_FREQUENCY.MILISEC);
  }
  // 1200000


  clearServerInterval() {
    if (this.serverCheckInterval) {
      clearInterval(this.serverCheckInterval);
    }
  }

  ngOnDestroy() {
    this.serverSubscription?.unsubscribe();
  }

}


